import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const removeProductsFromMpCategory = async ({ categoryId, body }) => {
  const path = `/mp_categories/${categoryId}/catalogue/delete/`;
  try {
    const response = await axiosInstance.patch(path, body);
    return response.data;
  } catch (error) {
    console.error('Remove Products from MP Category API error:', error);
    throw error;
  }
};

export const useRemoveFromMpCategories = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: removeProductsFromMpCategory,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['mpCatalogues'] });
      queryClient.invalidateQueries({ queryKey: ['mpCategories'] });
      queryClient.invalidateQueries({
        queryKey: ['mpCategories', variables.categoryId],
      });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    removeProductsFromMpCategory: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
